$('.input-file input[type="file"]').change(function (e) {
    const file = $(this)[0].files[0];

    if (!file) {
        return;
    }

    if (e.target.hasAttribute("data-file")) {
        const extension = file.name.split('.').pop();
        $(this).prev().children('div').text(e.target.dataset.file + '.' + extension)
    } else {
        $(this).prev().children('div').text(file.name)
    }
});

const review = $('.review');
const techErr = $('.tech-err');

let alignHeight = function () {
    //student review chat height align
    const video = $('#div-body').outerHeight(true);
    const content = $('.stream-content').height();
    const cardHeight = video + content;
    const inputMessage = $('.send-message').height();
    const hubspotForm = $('.hubspot-form');

    let formHeight = review.outerHeight(true);
    let padding = formHeight - review.height();

    let contentSessionHeight = cardHeight - formHeight - padding;
    hubspotForm.css({
        'height': contentSessionHeight
    });
    let MessageContainer = $('.message-container');
    let ReplayChatContainer = $('.replay-chat');

    MessageContainer.css({
        "height": contentSessionHeight - inputMessage,
        "max-height": contentSessionHeight - inputMessage,
        "scroll-behavior": "smooth"
    });
    ReplayChatContainer.css({
        "height": contentSessionHeight,
        "max-height": contentSessionHeight,
        "scroll-behavior": "smooth"
    });
}
let alignHeight2 = function () {
    //student tech err chat height align
    const video = $('#div-body').outerHeight(true);
    const content = $('.stream-content').height();
    const cardHeight = video + content;
    const inputMessage = $('.send-message').height();
    const hubspotForm = $('.hubspot-form');

    let formHeight = techErr.outerHeight(true);
    let padding = formHeight - techErr.height();

    let contentSessionHeight = cardHeight - formHeight - padding;
    hubspotForm.css({
        'height': contentSessionHeight
    });
    let MessageContainer = $('.message-container');
    let ReplayChatContainer = $('.replay-chat');

    MessageContainer.css({
        "height": contentSessionHeight - inputMessage,
        "max-height": contentSessionHeight - inputMessage,
        "scroll-behavior": "smooth"
    });
    ReplayChatContainer.css({
        "height": contentSessionHeight,
        "max-height": contentSessionHeight,
        "scroll-behavior": "smooth"
    });
}

$(function () {
    const studentLivestream = '/student/livestream';

    if (window.location.pathname === studentLivestream) {
        const carousels = [
            {
                prev: '.prev-live',
                next: '.next-live',
                slider: '#onGoingLives',
            },
            {
                prev: '.prev-up-live',
                next: '.next-up-live',
                slider: '#upComingLives',
            },
            {
                prev: '.prev-replay',
                next: '.next-replay',
                slider: '#replayCarousel',
            },
            {
                prev: '.last-prev-replay',
                next: '.last-next-replay',
                slider: '#lastReplayCarousel',
            },
            {
                prev: '.last-s-prev-replay',
                next: '.last-s-next-replay',
                slider: '#lastSeen',
            },
            {
                prev: '.prev-last-videos',
                next: '.next-last-videos',
                slider: '#lastVideos',
            },
        ];

        for (const {prev, next, slider} of carousels) {
            const prevButton = document.querySelector(prev);
            const nextButton = document.querySelector(next);

            if (prevButton && nextButton) {
                let counter = 0;

                prevButton.style.display = 'none';

                const scrollNext = (event) => {
                    event.preventDefault();

                    const carousel = document.querySelector(slider);
                    const cards = carousel.querySelectorAll('.carousel__item');
                    const cardWidth = cards[0].offsetWidth;
                    const cardMarginRight = parseInt(getComputedStyle(cards[0]).marginRight);

                    counter++;
                    carousel.scrollBy({
                        left: cardWidth + cardMarginRight,
                        behavior: 'smooth',
                    });

                    if (counter > 0) {
                        prevButton.style.display = 'block';
                    }
                };

                const scrollPrev = (event) => {
                    event.preventDefault();

                    const carousel = document.querySelector(slider);
                    const cards = carousel.querySelectorAll('.carousel__item');
                    const cardWidth = cards[0].offsetWidth;
                    const cardMarginRight = parseInt(getComputedStyle(cards[0]).marginRight);

                    counter--;
                    carousel.scrollBy({
                        left: -(cardWidth + cardMarginRight),

                        behavior: 'smooth',
                    });

                    prevButton.style.display = counter > 0
                        ? 'block'
                        : 'none';
                };

                nextButton.addEventListener('click', scrollNext);
                prevButton.addEventListener('click', scrollPrev);
            }
        }
    }

    // End cards carousels
    let reviewed = $('.rating-group input').toArray();
    let techErrIcon = $('.technical-problem__icon');
    let reviewNote = $('.rating__input');
    let reviewForm = function () {
        $('.rating-form').css('display', 'block');
        techErr.css('display', 'none');
        review.removeClass('col-md-11');
        review.addClass('col-md-12');
    }
    let techForm = function () {
        $('.tech-form').css('display', 'block');
        review.css('display', 'none');
        techErr.removeClass('col-md-1');
        techErr.addClass('col-md-12');
        $('.help-text').css('display', 'inline-block');
        $('.technical-problem__icon').addClass('active-icon');
    }

    $(reviewNote).on("click", function () {
        reviewForm();
        alignHeight();
    });

    $('.rating-group').click(function (event) {
        let radio_selector = 'input[type="radio"]',
            $radio;
        // Ignore the event when the radio input is clicked.
        if ($(event.target).is(radio_selector)) {
            $radio = $(event.target);
            if ($radio.is('#rating-5') || $radio.is('#rating-4')) {
                $('.bad-rating').css('display', 'none');
            } else {
                $('.bad-rating').css('display', 'block');
            }
        }
    });

    $(techErrIcon).on("click", function () {
        techForm();
        alignHeight2();
    });

    $('.cancel').on('click', function () {
        $('.tech-err').css('display', 'inline-flex');
        $('.tech-err').removeClass('col-md-12');
        $('.tech-err').addClass('col-md-1');
        review.css('display', 'inline-flex');
        review.removeClass('col-md-12');
        review.addClass('col-md-11');
        $('.tech-form').css('display', 'none');
        $('.rating-form').css('display', 'none');
        $('.help-text').css('display', 'none');
        $('.technical-problem__icon').removeClass('active-icon');
        alignHeight();
    });

    $('.submit').on('click', function () {
        alignHeight();
    });

    //student chat height align
    if ($(window).width() > 768) {
        alignHeight();
    }

    initHhubspotQuestionForm();
    initRatingForm();
    initLiveIssueForm();
});

$(window).on('load', function () {
    alignHeight();
})

$(window).on('resize', function () {
    alignHeight();
});

// end student chat resize

// Hubspot question form
const initHhubspotQuestionForm = () => {
    const $btnSubmit = $('#hubspot-form');
    if($btnSubmit.length === 0) {
        return;
    }

    $('#hubspot-checkbox').click(function () {
        if ($(this).is(':checked')) {
            $btnSubmit.removeAttr('disabled');
        } else {
            $btnSubmit.attr('disabled', 'disabled');
        }
    });

    $btnSubmit.click(() => {
        $btnSubmit.attr('disabled', 'disabled');
        const $form = $('form.question-form');
        const data = $form.serialize();
        const url = $form.attr('action');
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            dataType: 'Json',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            success: (response) => Toast.fire(response.success, '', 'success'),
            error: (error) => Toast.fire(JSON.parse(error.responseText).message, '', 'error'),
            complete: () => {
                $form[0].reset();
                $btnSubmit.removeAttr('disabled');
            }
        });
    });
};

// Rating form
const initRatingForm = () => {
    const $btnSubmit = $('#submit-review-live');
    if($btnSubmit.length === 0) {
        return;
    }

    $btnSubmit.click(() => {
        $btnSubmit.attr('disabled', 'disabled');
        const $form = $('#review-live');
        const data = $form.serialize();
        const url = $form.attr('action');
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            dataType: 'Json',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            success: (response) => Toast.fire(response.success, '', 'success'),
            complete: () => $('.rating-form').remove()
        });
    });
};

// Technical issue form
const initLiveIssueForm = () => {
    const $btnSubmit = $('#submit-live-issue');
    if($btnSubmit.length === 0) {
        return;
    }

    $btnSubmit.click(() => {
        $btnSubmit.attr('disabled', 'disabled');
        const $form = $('#live-issue');
        const data = $form.serialize();
        const url = $form.attr('action');
        $.ajax({
            type: 'POST',
            url: url,
            data: data,
            dataType: 'Json',
            headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
            success: (response) => Toast.fire(response.success, '', 'success'),
            complete: () => {
                $form[0].reset();
                $btnSubmit.removeAttr('disabled');
            }
        });
    });
};

let checkTextera = () => {
    const content = $("#eval-comment").val().trim();
    if (content === '') {
        $('.eval').attr('disabled', 'disabled');

    } else {
        $('#eval-comment').css({
            'border-color': ' #28a745',
            'background-color': '#f9fcf9',
        });
        $('.eval').removeAttr('disabled');
    }
};

$(document).on('keyup', '#eval-comment', checkTextera);

$('[data-toggle="popover"]').popover({
    html: true,
    content: function () {
        let id = $(this).data('id');
        let type = $(this).data('type');
        return $('#popover-' + type + '-' + id).html();
    }
});

// save video effect

$('.save-video').click(function () {
    $('.loading').addClass('active-loading');
});
